import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[appInputValidator]'
})
export class InputValidatorDirective {
  regexStr = '^[a-zA-Z 0-9.,-]*$';
  @Output() showInfo: EventEmitter<boolean> = new EventEmitter();
  constructor(private el: ElementRef) { }

  @HostListener('keypress',['$event'])
  onKeyPress(event) {
    //console.log('keypress');
    var status = new RegExp(this.regexStr).test(event.key);
    this.showInfo.emit(status);
    return status;
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: ClipboardEvent) {
    this.validateFields(event);
  }
  validateFields(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text/plain').replace(/[^a-zbA-Z 0-9.,-]/g, '');
    //console.log('paste');   
    document.execCommand('insertHTML', false, pasteData);
    var status = new RegExp(this.regexStr).test(event.clipboardData.getData('text/plain'));
    this.showInfo.emit(status);
    }

}
